import { grianaProjectActions } from '@bvt-features/pertamina/store/griana-project/griana_project.slice';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const usePertaminaGriana = () => {
  const state = useSelector((state) => state.features.PERTAMINA.grianaProject);
  const dispatch = useDispatch();

  const projectDetail = useMemo(() => ({
    projectID: state.projectID,
    processID: state.processID,
    name: state.name,
  }), [state.projectID]);
  const setProjectDetail = (param) => dispatch(grianaProjectActions.setProjectDetail(param));

  return {
    projectDetail,
    setProjectDetail,
    state,
  };
};
